import dayjs from "dayjs";
import { updateBasketBar } from "./basket-bar/updateBasketBar";
import { initAddToBasketV2, initAddToBasketV2Bulk, setBasketExpiryTimer } from "./basket-v2";
import { getBasketData } from "./basket-v2/api/getBasketData";
import { renderBasketPageV2 } from "./basket-v2/renderBasketPageV2";
import { updateDropdownsFromServer } from "./basket-v2/updateDropdownsFromServer";
import { getEventBasketType } from "./common/getEventBasketType";
import { isBasketPage } from "./common/isBasketPage";



export async function initTicketing(): Promise<void> {
  // Can we get this to check the basket type for the page instead?

  await initBasketV2();

  if (isBasketPage()) {
    await renderBasketPageV2();
  }
  else if (getEventBasketType() === "v2") {
    initAddToBasketV2();
    initAddToBasketV2Bulk();
    await updateDropdownsFromServer();
  }
}

async function initBasketV2(): Promise<void> {
  const { data } = await getBasketData();

  if (!!data) {
    const { checkoutUrl, total, totalItems, basketUrl, expiryTime } = data;
    const url = isBasketPage() ? checkoutUrl : basketUrl;

    setBasketExpiryTimer(dayjs(expiryTime), url);
    updateBasketBar({
      total,
      totalItems,
      checkoutUrl: url,
    });
    //await updateDropdownsFromServer();
  }
}
